import React from 'react';

import { cx } from '@emotion/css';
import { ImageComponent } from '@modules/services/Components';

import styles from './foundersView.module.scss';

const Founder = ({ url, alt, name, role }: any) => {
  return (
    <div className={styles.founders_item}>
      <div className={styles.founders_item_img}>
        <ImageComponent src={url} alt={alt} className={styles.founders_image} />
        <div className={styles.founders_content}>
          <h6 className={cx(styles.founders_content_text, styles.h5)}>
            {name}
          </h6>
          <p className={cx(styles.founders_content_text, styles.p)}>{role}</p>
        </div>
      </div>
    </div>
  );
};

export const FoundersView = () => {
  const founderImages = [
    {
      url: '/images/about-us/james.jpeg',
      alt: 'James Catto',
      name: 'James Catto',
      role: 'CEO & Co-Founder',
    },
    {
      url: '/images/about-us/jack.jpg',
      alt: 'Jack Marcham',
      name: 'Jack Marcham',
      role: 'COO & Co-Founder',
    },
    {
      url: '/images/about-us/sushil.jpeg',
      alt: 'Sushil Bansal',
      name: 'Sushil Bansal',
      role: 'CTO & Co-Founder',
    },
  ];
  return (
    <section className={styles.about_us}>
      <div className={styles.root}>
        <div className={styles.about_us_card_block}>
          <div className={styles.container}>
            <div className={styles.inner_section}>
              <div className={styles.heading_wrapers}>
                <h2 className={cx(styles.site_title, styles.h2)}>
                  Our Founders
                </h2>

                <div className={styles.founders_gallery}>
                  {founderImages.map((founder) => (
                    <Founder
                      url={founder.url}
                      key={founder.name}
                      name={founder.name}
                      role={founder.role}
                      alt={founder.alt}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
